// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDownRightAndArrowUpLeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down-right-and-arrow-up-left': IconArrowDownRightAndArrowUpLeft;
    }
}

/**
 * The icon component for the 'arrowDownRightAndArrowUpLeft' icon
 */
export class IconArrowDownRightAndArrowUpLeft extends Icon {
    public constructor() {
        super(arrowDownRightAndArrowUpLeft16X16);
    }
}

registerIcon('icon-arrow-down-right-and-arrow-up-left', IconArrowDownRightAndArrowUpLeft);
export const iconArrowDownRightAndArrowUpLeftTag = 'nimble-icon-arrow-down-right-and-arrow-up-left';
